export default __webpack_public_path__ + "static/media/prebuilt-cases.6f496280.svg";